import { Box } from '@osmosis/react-ui/components/Box';
import { Flex } from '@osmosis/react-ui/components/Box';
import { Icon } from '@osmosis/react-ui/components/Icon';
import { FormattedMessage } from 'react-intl';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons/faCircleXmark';
import { P } from '@osmosis/react-ui/components/Text';
import { SxStyleProp } from 'rebass';

interface PropsI {
  isCorrectAnswer: boolean;
  explanation?: string;
  sx?: SxStyleProp;
}

/**
 * CorrectBanner.
 */
export const CorrectBanner = ({ isCorrectAnswer, explanation, sx }: PropsI) => {
  return (
    <Flex
      sx={{
        bg: isCorrectAnswer ? 'positiveLight' : 'negativeLight',
        border: '1px solid',
        borderRadius: '5px',
        borderColor: isCorrectAnswer ? 'positive' : 'negative',
        color: isCorrectAnswer ? 'positiveText' : 'negativeText',
        ...sx,
      }}
      p="10px"
      my="20px"
      alignItems="center"
    >
      <Flex fontSize="2em" mr="10px">
        <Icon icon={isCorrectAnswer ? faCheckCircle : faCircleXmark} />
      </Flex>
      <Box>
        <P
          fontWeight="bold"
          color={isCorrectAnswer ? 'positiveText' : 'negativeText'}
        >
          {isCorrectAnswer ? (
            <FormattedMessage
              id="quiz.answer-banner.positive"
              defaultMessage="You did it! This is correct"
            />
          ) : (
            <FormattedMessage
              id="quiz.answer-banner.negative"
              defaultMessage="
              Sorry, this is incorrect"
            />
          )}
        </P>
        {explanation && <P dangerouslySetInnerHTML={{ __html: explanation }} />}
      </Box>
    </Flex>
  );
};
